import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const options = this.element.dataset.options ? JSON.parse(this.element.dataset.options) : {}

    const element = this.element
    $(this.element).select2({
      theme: "bootstrap",
      placeholder: this.element.dataset.placeholder || "Select...",
      allowClear: true,
      width: "100%",
      templateResult: (data) => {
        const selectedIds = new Set(Array.from(element.selectedOptions).map((o) => o.value))
        return selectedIds.has(String(data.id)) ? null : data.text
      },
      ...options,
    })

    $(this.element).on("change.select2", () => {
      this.#sortChips()
      if (this.element.dataset.preserveUrlSyncing === "true") return
      const form = this.element.closest("form")
      if (form) form.requestSubmit()
    })

    this.#sortChips()
  }

  #sortChips() {
    const $rendered = $(this.element).data("select2").$container
      .find(".select2-selection__rendered")
    const $search = $rendered.find(".select2-search--inline")
    $rendered.find(".select2-selection__choice").toArray()
      .sort((a, b) => $(a).attr("title").localeCompare($(b).attr("title"), undefined, { sensitivity: "base" }))
      .forEach(el => $(el).insertBefore($search))
  }

  disconnect() {
    if ($(this.element).data("select2")) {
      $(this.element).select2("destroy")
    }
  }
}
